module.exports = __webpack_public_path__ + "static/media/dev sharma ji_page-0001 (1).5257ff94.jpg";